import React, { useEffect, useState } from "react";
import { object, array, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TagStorySearch from "../../molecules/TagStorySearch";
import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import Organism3 from "./Organism3";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import DfpAd from "../../dfp-ad";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./sixStories1WidgetWithPoll.m.css";

const SixStories1WidgetWithPoll = ({
  collection,
  sections,
  isSectionComponent = false,
  firstStoriesSet,
  widgetUrl = null,
  widgetHeight = null,
  lang,
  domainSlug,
}) => {
  let collectionItems = [];

  if (!isSectionComponent) {
    collectionItems =
      collection &&
      collection.items &&
      collection.items.length > 0 &&
      collection.items.filter((item) => item.type === "collection").slice(0, 2);
  }
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const firstCollection = collectionItems && collectionItems.length > 0 ? collectionItems[0] : null;
  const secondCollection = collectionItems && collectionItems.length > 1 ? collectionItems[1] : null;

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = getSlug(collection, sections, domainSlug, navigateTo);
  const stories =
    firstCollection &&
    firstCollection.items &&
    firstCollection.items.length > 0 &&
    firstCollection.items.filter((item) => item.type === "story");
  const storiesSet = stories && stories.length ? stories.slice(0, 6) : null;
  const storyList = isSectionComponent ? firstStoriesSet : storiesSet;

  if (!(storyList && storyList.length)) {
    return null;
  }

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
  }, []);

  const widgetPollingView = () => (
    <div styleName="widget-polling">
      {isSectionComponent ? (
        <div styleName="side-ad">
          <DfpAd
            adtype={lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1"}
            collectionSlug={collectionSlug}
            slotId="sectionSixStories1WidgetWithPoll"
          />
          {widgetUrl && String(widgetUrl).toLocaleLowerCase().includes("localsearch") ? (
            <TagStorySearch className="tag-story" />
          ) : (
            widgetUrl && (
              <iframe
                title="Six stories 1 widget with poll"
                src={widgetUrl}
                styleName="widget-iframe"
                style={widgetHeight ? { height: `${widgetHeight}px` } : {}}
              ></iframe>
            )
          )}
        </div>
      ) : secondCollection ? (
        <Organism3 isMobile={isMobile} collection={secondCollection} sections={sections} domainSlug={domainSlug} />
      ) : null}
    </div>
  );

  return (
    <div styleName="base" className="six-stories-1widget-poll">
      <div>
        {showCollectionName && (
          <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
        )}

        <div styleName="wrapper">
          <Organism1 stories={storyList.slice(0, 2)} isMobile={isMobile} />

          <div styleName="story-widget-view">
            <Organism2 stories={storyList.slice(2, 6)} />
          </div>
        </div>
      </div>

      {widgetPollingView()}
    </div>
  );
};

SixStories1WidgetWithPoll.propTypes = {
  collection: object,
  sections: array,
  isSectionComponent: bool,
  firstStoriesSet: array,
  widgetUrl: string,
  widgetHeight: string,
  lang: string,
  domainSlug: string,
};

SixStories1WidgetWithPoll.nestedCollectionLimit = [6, 3];

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(SixStories1WidgetWithPoll);
